import React, { lazy, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"; 

import Loading from "./Loading";
import NavigationMenu from "./NavigationMenu";
import { GPSProvider } from "./GPSContext";
import "./App.css";

const About = lazy(() => import("./About"));
const SpeedOmeter = lazy(() => import("./SpeedOmeter"));
const Footer = lazy(() => import("./Footer"));
const Leaderboard = lazy(() => import("./Leaderboard"));
const Settings = lazy(() => import("./Settings"));

const App: React.FC = () => (
  <Router>
    <GPSProvider>
      <Suspense fallback={<Loading />}>
        <NavigationMenu />

        <Routes>
          <Route path='/about' element={<About/>} />
          <Route path='/leaderboard' element={<Leaderboard/>} />
          <Route path='/settings' element={<Settings/>} />
          <Route path='/' element={<SpeedOmeter/>} />
        </Routes>
      </Suspense>
      <Footer />
    </GPSProvider>
  </Router>
);

export default App;